module.exports = __webpack_public_path__ + "img/video-player/step-forward-five-4308d9766aaa5b2c70b73b5ad97ab3aa.svg";